export const BrandMentionsIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='1'>
        <path
          d='M7.9987 2.00065H10.7987C11.9188 2.00065 12.4788 2.00065 12.9067 2.21864C13.283 2.41038 13.589 2.71634 13.7807 3.09267C13.9987 3.52049 13.9987 4.08054 13.9987 5.20065V10.8006C13.9987 11.9208 13.9987 12.4808 13.7807 12.9086C13.589 13.285 13.283 13.5909 12.9067 13.7826C12.4788 14.0006 11.9188 14.0006 10.7987 14.0006H5.1987C4.07859 14.0006 3.51854 14.0006 3.09072 13.7826C2.71439 13.5909 2.40843 13.285 2.21668 12.9086C1.9987 12.4808 1.9987 11.9208 1.9987 10.8006V8.00065M5.33203 8.66732V11.334M10.6654 7.33398V11.334M7.9987 4.66732V11.334M5.33203 3.33398L3.33203 1.33398L1.33203 3.33398M3.33203 1.33398V5.33398'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
